import { createSlice } from "@reduxjs/toolkit";
import { ILeaveTypeSlice } from "./types";
import { fetchLeaveTypeList, upsertLeaveType, deleteLeaveType } from "./thunks";

const initialState: ILeaveTypeSlice = {
  leaveTypeList: [],
  isLoading: false,
  isError: false,
};

export const leaveTypeSlice = createSlice({
  name: "leaveType",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Fetch
    builder.addCase(fetchLeaveTypeList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchLeaveTypeList.fulfilled, (state, action) => {
      state.leaveTypeList = action.payload || [];
      state.isLoading = false;
    });
    builder.addCase(fetchLeaveTypeList.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });

    // Upsert
    builder.addCase(upsertLeaveType.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(upsertLeaveType.fulfilled, (state, action) => {
      state.isLoading = false;
      const updated = action.payload;
      if (!updated) return;

      const index = state.leaveTypeList.findIndex(
        (item) => item.id === updated.id
      );
      if (index !== -1) {
        state.leaveTypeList[index] = updated;
      } else {
        state.leaveTypeList.push(updated);
      }
    });
    builder.addCase(upsertLeaveType.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });

    // Soft delete
    builder.addCase(deleteLeaveType.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteLeaveType.fulfilled, (state, action) => {
      state.isLoading = false;
      const id = action.payload;
      const index = state.leaveTypeList.findIndex((l) => l.id === id);
      if (index !== -1) {
        state.leaveTypeList[index].isActive = false;
      }
    });
    builder.addCase(deleteLeaveType.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });
  },
});

export const { reducer } = leaveTypeSlice;
